import { ServerWideBackupConfiguration } from "../../ServerWide/Operations/Configuration/ServerWideBackupConfiguration.js";

export interface GetServerWideBackupConfigurationsResponse {
    results: ServerWideBackupConfiguration[];
}